<template>
    <a-modal v-model="visible" :title="title" :width="width" centered :maskClosable="false" :keyboard="false">
        <a-spin :spinning="loading">
            <a-form class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="序号">
                            <a-input-number ref="xh" v-model="editData.xh" :min="0" style="width:100%" disabled />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="项目名称" required>
                            <a-input ref="xmmc" v-model="editData.xmmc" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="专业编号" required>
                            <a-input-search read-only ref="zybh" @search="isShow_zyxx = true" v-model="editData.zybh" />
                            <FGDataSelect :isShow.sync="isShow_zyxx" selectNo="JC1002" @saveselect="saveEvent_zyxx(arguments)"></FGDataSelect>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="专业名称">
                            <a-input ref="zymc" v-model="editData.zymc" disabled />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="咨询服务范围" required>
                            <a-input ref="zxfwfw" v-model="editData.zxfwfw" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="建设规模" required>
                            <a-input ref="jsgm" v-model="editData.jsgm" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="固定资产投资额" required>
                            <a-input-number
                                ref="gdzctze"
                                v-model="editData.gdzctze"
                                :min="0"
                                :step="0.01"
                                :formatter="
                                    (value) => {
                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                    }
                                "
                                :parser="
                                    (value) => {
                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                    }
                                "
                                style="width:100%"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="委托单位名称" required>
                            <a-input ref="wtdwmc" v-model="editData.wtdwmc" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="委托单位联系人" required>
                            <a-input ref="wtdwlxr" v-model="editData.wtdwlxr" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="委托单位电话" required>
                            <a-input ref="wtdwdh" v-model="editData.wtdwdh" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 9]">
                    <a-col :span="24">
                        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" />
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
            <a-button type="primary" :loading="saving || loading" @click="onSave">
                保存
            </a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    name: "YyxmAdd",
    props: ["showEdit", "xh", "dataId", "yyxmbid"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 编辑数据
            editData: {},
            editDataLoading: false,
            isShow_zyxx: false
        };
    },
    computed: {
        title() {
            return this.dataId ? "编辑" : "新增";
        },
        visible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        width() {
            return 1200;
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    if (!this.dataId) {
                        // 新增，设置默认值
                        this.editData = {
                            isnew: true,
                            id: this.$FG_util.uuid(),
                            xh: this.xh,
                            yyxmbid: this.yyxmbid
                        };
                    } else {
                        this.loadData();
                    }
                    // 设置光标位置
                    this.$nextTick(() => {
                        this.$refs.xh.focus();
                    });
                }
            },
            immediate: true
        }
    },
    methods: {
        saveEvent_zyxx(val) {
            if (val && val.length > 0) {
                this.editData.zyid = val[0][0].ID;
                this.editData.zybh = val[0][0].ZYBH;
                this.editData.zymc = val[0][0].ZYMC;
            }
        },
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/selectYyxmById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.visible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.visible = false;
                    }
                });
        },
        //保存
        onSave() {
            // 表单校验
            if (!this.editData.zybh) {
                this.$FG_message.error("P0001", "专业编号").then(() => this.$refs.zybh.focus());
                return;
            }
            if (!this.editData.zxfwfw) {
                this.$FG_message.error("P0001", "咨询服务范围").then(() => this.$refs.zxfwfw.focus());
                return;
            }
            if (!this.editData.jsgm) {
                this.$FG_message.error("P0001", "建设规模").then(() => this.$refs.jsgm.focus());
                return;
            }
            if (!this.editData.gdzctze) {
                this.$FG_message.error("P0001", "固定资产投资额").then(() => this.$refs.gdzctze.focus());
                return;
            }
            if (!this.editData.wtdwmc) {
                this.$FG_message.error("P0001", "委托单位名称").then(() => this.$refs.wtdwmc.focus());
                return;
            }
            if (!this.editData.wtdwlxr) {
                this.$FG_message.error("P0001", "委托单位联系人").then(() => this.$refs.wtdwlxr.focus());
                return;
            }
            if (!this.editData.wtdwdh) {
                this.$FG_message.error("P0001", "委托单位电话").then(() => this.$refs.wtdwdh.focus());
                return;
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post("./api/main/dwdcgl/dwdc/saveYyxm", {
                    data: this.editData
                })
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 返回列表
                        this.visible = false;
                        // 通知父组件数据已更新
                        this.$emit("dataUpdated", this.editData.id);
                    } else {
                        this.$refs.xh.focus();
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        }
    }
};
</script>
